import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { AUTH_PATH } from "../../router/path/auth";
import { useAuth } from "../../hooks/useAuth";
import { WIX_ENV } from "../../utils";
import {
  selectSettings,
  selectWixGetParam,
} from "../../store/settings/settingsSlice";
import ModalRole from "../../components/ModalRole";
import { useLazyGetAfterLoginQuery } from "../../store/authentication/authService";
import { usePublicConfig } from "../../hooks/usePublicConfig";
import { setRegistration } from "../../store/authentication/authSlice";

const AuthProviders = () => {
  const { options } = useSelector(selectSettings);
  const wixGetParam = useSelector(selectWixGetParam);
  const { user } = useAuth();
  const { env } = usePublicConfig();
  const [openModal, setOpenModal] = useState(false);
  const [triggerGetAfterLogin] = useLazyGetAfterLoginQuery();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!WIX_ENV?.includes(env?.hostEnv)) return;

    if (Object.keys(wixGetParam || {}).length > 0) {
      triggerGetAfterLogin(wixGetParam)
        .unwrap()
        .catch((error) => console.error(error));
    }
  }, [wixGetParam]);

  useEffect(() => {
    if (!user?.business_role && options?.business_role?.required_in_popup) {
      setOpenModal(true);
    }
  }, [user, options]);

  useEffect(() => {
    dispatch(setRegistration(false));
  }, []);

  const hasUserId = Boolean(user?.id);
  const action = hasUserId ? "outlet" : "navigate-login";

  return hasUserId ? (
    <>
      {openModal && <ModalRole open={openModal} close={setOpenModal} />}
      <Outlet />
    </>
  ) : (
    <Navigate to={AUTH_PATH.LOGIN} replace />
  );
};

export default AuthProviders;
